import type {
  DeliveryWindowCapacityListApiData,
  DeliveryWindowCapacityListApiResponses,
  DeliveryWindowCreateApiData,
  DeliveryWindowCreateApiResponses,
  DeliveryWindowDeleteApiData,
  DeliveryWindowDeleteApiResponses,
  DeliveryWindowEarliestDateForNewBookingApiData,
  DeliveryWindowEarliestDateForNewBookingApiResponses,
  DeliveryWindowForBookingListApiData,
  DeliveryWindowForBookingListApiResponses,
  DeliveryWindowGetApiData,
  DeliveryWindowGetApiResponses,
  DeliveryWindowGroupListApiData,
  DeliveryWindowGroupListApiResponses,
  DeliveryWindowLatestDateForNewBookingApiData,
  DeliveryWindowLatestDateForNewBookingApiResponses,
  DeliveryWindowListApiData,
  DeliveryWindowListApiResponses,
  DeliveryWindowPatchApiData,
  DeliveryWindowPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

// Registered by `impersonationBypass`, not the domain map, so call sites use `...IgnoringImpersonation`.
export const getLatestDeliveryWindowEndpoint = dataEndpoint<
  DeliveryWindowLatestDateForNewBookingApiData,
  DeliveryWindowLatestDateForNewBookingApiResponses
>({
  getUrl: (queryParams) => apiUrl('delivery-windows/latest-date/', queryParams)
});

export const getFirstAvailableDeliveryWindowEndpoint = responseEndpoint<
  DeliveryWindowEarliestDateForNewBookingApiData,
  DeliveryWindowEarliestDateForNewBookingApiResponses
>({
  getUrl: () => apiUrl('delivery-windows/earliest-date/'),
  getBody: (data) => data
});

export const getDeliveryWindowUrls = {
  postDeliveryWindow: responseEndpoint<DeliveryWindowCreateApiData, DeliveryWindowCreateApiResponses>({
    getUrl: () => apiUrl('delivery-windows/'),
    getBody: (data) => data
  }),
  deleteDeliveryWindow: dataEndpoint<DeliveryWindowDeleteApiData, DeliveryWindowDeleteApiResponses>({
    getUrl: ({ deliveryWindowId }) => apiUrl(`delivery-windows/${deliveryWindowId}/`),
    getBody: (data) => data
  }),
  patchDeliveryWindow: responseEndpoint<DeliveryWindowPatchApiData, DeliveryWindowPatchApiResponses>({
    getUrl: ({ deliveryWindowId }) => apiUrl(`delivery-windows/${deliveryWindowId}/`),
    getBody: (data) => data
  }),
  getDeliveryWindow: dataEndpoint<DeliveryWindowGetApiData, DeliveryWindowGetApiResponses>({
    getUrl: ({ deliveryWindowId }) => apiUrl(`delivery-windows/${deliveryWindowId}/`)
  }),
  getDeliveryWindowsWithCapacity: dataEndpoint<
    DeliveryWindowCapacityListApiData,
    DeliveryWindowCapacityListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('delivery-windows/capacity/', queryParams)
  }),
  getPaginatedDeliveryWindowGroups: dataEndpoint<DeliveryWindowGroupListApiData, DeliveryWindowGroupListApiResponses>({
    getUrl: (queryParams) => apiUrl('delivery-window-groups/', queryParams)
  }),
  getPaginatedDeliveryWindows: dataEndpoint<DeliveryWindowListApiData, DeliveryWindowListApiResponses>({
    getUrl: (queryParams) => apiUrl('delivery-windows/', queryParams)
  }),
  getAvailableBookingTimeWindowsByDate: dataEndpoint<
    DeliveryWindowForBookingListApiData,
    DeliveryWindowForBookingListApiResponses
  >({
    getUrl: (args) => apiUrl('delivery-windows/for-booking/', args)
  })
};
